export default {
	lang: 'de',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav":"VORMOR-KI",
		"nav2":"Kontosicherheit",
		"nav3":"Meine Cloud-Festplatte",
		"nav4":"Ausloggen",
		"nav5":"Einloggen",
		"nav6":"Cloud-Speicherplatz",
		"nav7":"ChatGPT großes Modell",
		"nav8":"Intelligentes Sprachrekorder-Cloud-Space-System",
		"nav_phone_number_code":'Handynummer',
		"nav_update": 'Austausch',
		"nav_bind":'binden',
		"nav_phone_code_tips":'Um sicherzustellen, dass Sie die Aktion selbst durchführen, bestätigen Sie bitte Ihre Identität mit der Handynachrichten-Code.',
		"nav_phone_number":'Handynummer',
		"nav_phone_number_verify":'Handynummer-Verifizierung umschalten',
		"nav_phone_email_verify": "E-Mail-Verifizierung umschalten",
		"nav_set_phone_number":'Neue Handynummer festlegen',
		"nav_verify_login":'Anmeldung verifizieren',
		"nav_phone_email":'E-Mail/Handynummer',
		"nav_phone_login": "Login mit Handy-Verifizierung",
		"nav_email_login":'E-Mail-Verifizierung zum Anmelden',
		"nav_email_fail":'E-Mail-Format ist falsch, bitte geben Sie es erneut ein',
		"nav_pw_fail":'Das Passwortformat ist falsch, bitte geben Sie es erneut ein',
		"nav_code_fail":'Falscher Sicherheitscode',
		"nav_phone_fail":'Fehlerhafter Handynummer-Format, bitte geben Sie die Nummer erneut ein',
		"nav_input_fail":'Geben Sie eine E-Mail-Adresse ein',
		"nav_input_phone":'Geben Sie eine Handynummer ein',
		"nav_phone_verify_back":'Handynachweis zur Wiederherstellung',
		"nav_email_verify_back": "E-Mail-Verifizierung zur Wiederherstellung"
	},
	login: {
		"login1":"Passwort-Login",
		"login2":"SMS-Anmeldung",
		"loginTab3":"E-Mail-Anmeldung",
		"login3":"Mail",
		"login4":"Login-Passwort",
		"login5":"Telefonnummer",
		"login6":"Bitte wählen",
		"login7":"Mobiler Bestätigungscode",
		"login8":"Einloggen",
		"login9":"Passwort vergessen",
		"login10":"registrieren",
		"login11":"Mit der Anmeldung erklären Sie sich einverstanden",
		"login12":"Servicevereinbarung",
		"login13":"Datenschutzrichtlinie",
		"login14":"Erhalten",
		"login15":"China",
		"login16":"Bitte geben Sie Ihre Kontonummer ein",
		"login17":"Bitte geben Sie Ihr Passwort ein",
		"login18":"Erfolgreich angemeldet!",
		"login19":"Bitte geben Sie den Bestätigungscode ein!",
		"login20":"Erfolgreich gesendet!",
		"login21":"Und",
		"login22":"Sprachrekorder-Cloud-Disk",
		"login23":"Mein Schreiben",
		"login24":"Mein Gespräch",
		"login25":"Kontosicherheit",
		"login26":"Ausloggen",
		"login27":"Passwort per E-Mail abrufen",
		"login28":"Mail",
		"login29":"E-Mail-Bestätigungscode",
		"login30":"Legen Sie ein Login-Passwort fest (6-16 Zeichen)",
		"login31":"Geben Sie Ihr Login-Passwort erneut ein",
		"login32":"einreichen",
		"login33":"Zurück zur Anmeldung",
		"login34":"Änderung erfolgreich!",
	},
	register: {
		"register1":"Telefonnummer",
		"register2":"Bitte geben Sie Ihre Telefonnummer ein",
		"register3":"Bitte wählen",
		"register4":"Mobiler Bestätigungscode",
		"register5":"Passwort festlegen",
		"register6":"Bitte geben Sie den Bestätigungscode ein",
		"register7":"6-16 Zeichen",
		"register8":"Passwortbestätigung",
		"register9":"Mail",
		"register10":"Bitte geben Sie Ihre E-Mail-Adresse ein",
		"register11":"E-Mail-Bestätigungscode",
		"register12":"Bitte geben Sie den Bestätigungscode ein",
		"register13":"Ich habe gelesen und stimme zu",
		"register14":"Bitte lesen Sie und kreuzen Sie das Kästchen an, mit dem Sie der Vereinbarung zustimmen",
		"register15":"Das Telefonnummernformat ist falsch/die Telefonnummer wurde registriert",
		"register16":"Fehler beim mobilen Bestätigungscode",
		"register17":"Bitte geben Sie Ihre E-Mail-Adresse ein. / Das Format der E-Mail-Adresse ist falsch.",
		"register18":"Fehler im E-Mail-Format",
		"register19":"Fehler beim E-Mail-Bestätigungscode",
		"register20":"Bitte legen Sie das Passwort auf 6-16 Zeichen fest",
		"register21":"Fehler im Kennwortformat",
		"register22":"Die von Ihnen zweimal eingegebenen Passwörter stimmen nicht überein. Bitte wiederholen Sie die Eingabe.",
		"register23":"Bitte geben Sie Ihr Passwort ein",
		"register24":"Registrierung erfolgreich!",
		"register25":"Fehler beim Bestätigungscode",
	},
	recorder:{
		"recorder1":"Sprachrekorder-Cloud-Disk",
		"recorder2":"Cloud-Speicherplatzkapazität",
		"recorder3":"dokumentieren",
		"recorder331":"Papierkorb",
		"recorder332":"Alles löschen",
		"recorder4":"Name",
		"recorder5":"Audiodauer",
		"recorder6":"Dateigröße",
		"recorder7":"Erstellungszeit",
		"recorder8":"arbeiten",
		"recorder9":"Beschreibung des Cloud-Raums",
		"recorder10":"dokumentieren",
		"recorder11":"OCR-Datei",
		"recorder12":'1. Nutzung des Cloud-Raums',
		"recorder13": 'Nachdem Sie Aufnahmen auf einem Smart-Office-Buch oder einem Tonschreiber gespeichert haben, können Sie Ihre Notizen in der Cloud hochladen, auch wenn Ihr Smart-Gerät nicht in Ihrer Nähe ist, können Sie in den Cloud-Raum gelangen, um Ihre Notizdateien anzuzeigen. ',
		"recorder14":'2. Wie kann ich den Cloud-Raum hochladen? ',
		"recorder15":'Aufzeichnungsstift: Gehen Sie zu Gerät → Meine Dateien → Klicken Sie auf Batch-Aktionen → Klicken Sie auf "Hochladen", um Dateien in die Cloud-Upload-Warteschlange hinzuzufügen und in die Cloud hochzuladen. ',
		"recorder16":'Intelligentes Bürobuch:',
		"recorder17":'Methode 1: In der Notizenliste lang drücken, die Notizen, die hochgeladen werden sollen, in der Menge auswählen → Klicken Sie auf "Synchronisieren" zum Abschluss des Hochladens; ',
		"recorder171":'Methode 2: Öffnen Sie die Detailseite der einzelnen Notiz → Klicken Sie auf Mehr - Synchronisieren, um die Notiz in die Cloud hochzuladen. ',
		"recorder18":"Nicht transkribiert",
		"recorder19":"Zusammenfassung anzeigen",
		"recorder20":"Lautsprecher",
		"recorder21":"Sprechernamen bearbeiten",
		"recorder22":"Sicher",
		"recorder23":"herunterladen",
		"recorder24":"Inhalt herunterladen:",
		"recorder25":"Download-Einstellungen:",
		"recorder26":"Sprecher anzeigen",
		"recorder27":"Stornieren",
		"recorder28":"Link-Sharing",
		"recorder29":"Jeder, der den Link erhält, kann darauf zugreifen. Er dient ausschließlich zum Lesen und ist 7 Tage gültig.",
		"recorder30":"Link kopieren",
		"recorder31":"Scannen und schnell ansehen",
		"recorder32":"Intelligente Organisation",
		"recorder33":"Unterscheiden Sie zwischen Sprechern",
		"recorder34":"Intelligente Unterscheidung des transkribierten Textes entsprechend der Sprecherrolle",
		"recorder35":"Intelligente Regularisierung gesprochener Sprache",
		"recorder36":"Filtern Sie automatisch Modalpartikel, wiederholte Wörter und Pausenwörter",
		"recorder37":"Nicht-stimmliche Filterung",
		"recorder38":"Audio ohne Stimme oder Rauschen während der Wiedergabe automatisch überspringen",
		"recorder39":"Bitte wählen",
		"recorder40":"dokumentieren",
		"recorder41":"Audio",
		"recorder42":"Dokumente + Audio",
		"recorder43":"Hinweis",
		"recorder44":"Dieser Vorgang löscht Dateien. Möchten Sie fortfahren?",
		"recorder441":"Dieser Vorgang löscht alle Dateien. Möchten Sie fortfahren?",
		"recorder45":"Sicher",
		"recorder46":"Stornieren",
		"recorder47":"Erfolgreich gelöscht!",
		"recorder48":"Wiederhergestellt",
		"recorder49":"Noch keine Tags",
		"recorder50":"Speichern...",
		"recorder51":"Papierkorb",
	},
	personal: {
		"personal1":"Kontoeinstellungen",
		"personal2":"persönliche Informationen",
		"personal3":"Avatar",
		"personal4":"Dateien hochladen",
		"personal5":"Unterstützt JPG, JPEG, GIF, PNG-Stile, unterstützt Bilder innerhalb von 2M",
		"personal6":"Spitzname",
		"personal7":"Bitte geben Sie Ihren Spitznamen ein",
		"personal8":"Geschlecht",
		"personal9":"Herren",
		"personal10":"Vermissen",
		"personal11":"Vertraulichkeit",
		"personal12":"Geburtstag",
		"personal13":"Bitte wählen Sie Ihren Geburtstag",
		"personal14":"Beruf",
		"personal15":"Bitte wählen Sie Ihren Beruf",
		"personal16":"Bitte geben Sie Ihren Beruf ein (optional)",
		"personal17":"Nation",
		"personal18":"Wählen Sie Ihr Land",
		"personal19":"halten",
		"personal20":"persönliche Informationen",
		"personal21":"Kontosicherheit",
		"personal22":"Unterstützt nur Bilder innerhalb von 2M",
		"personal23":"Hochladen erfolgreich!",
		"personal24":"Änderung erfolgreich!",
		"personal25":"Kontosicherheit",
		"personal26":"Login-Passwort",
		"personal27":"Überarbeiten",
		"personal28":"E-Mail",
		"personal29":"ersetzen",
		"personal30":"Kontoauflösung",
		"personal32":"Möchten Sie Ihr Konto wirklich auflösen?",
		"personal33":"Nach der Abmeldung werden alle Inhalte Ihres Kontos gelöscht. Gehen Sie daher bitte vorsichtig vor.",
		"personal34":"Stornieren",
		"personal35":"Sicher",
		"personal36":"Authentifizierung",
		"personal37":"Um zu bestätigen, dass Sie es sind, der dies tut, schließen Sie bitte die Identitätsprüfung per E-Mail-Bestätigungscode ab",
		"personal38":"Mail",
		"personal39":"Bestätigungscode",
		"personal40":"Bitte geben Sie den Bestätigungscode ein",
		"personal41":"Nächster Schritt",
		"personal42":"Einrichten eines neuen Postfachs",
		"personal43":"Mail",
		"personal44":"Bitte geben Sie eine neue E-Mail-Adresse ein",
		"personal45":"Bestätigungscode",
		"personal46":"Bitte geben Sie den Bestätigungscode ein",
		"personal47":"Sicher",
		"personal48":"Legen Sie ein neues Anmeldekennwort fest",
		"personal49":"Neues Login-Passwort",
		"personal50":"Bitte geben Sie ein neues Passwort ein",
		"personal51":"Neues Passwort bestätigen",
		"personal52":"Bitte geben Sie Ihr neues Passwort erneut ein",
		"personal53":"Sicher",
		"personal54":"Erhalten",
		"personal55":"Fehler im E-Mail-Format",
		"personal56":"Austausch erfolgreich!",
		"personal57":"Bitte legen Sie das Passwort auf 6-16 Zeichen fest",
		"personal58":"Die von Ihnen zweimal eingegebenen Passwörter stimmen nicht überein",
		"personal59":"Änderung erfolgreich!",
		"personal60":"Abmeldung erfolgreich!",
		"share_url": "Link teilen",
		"share_url_7_day": "Der Freigabelink ist 7 Tage gültig. Vor Ablauf kann jeder, der den Link erhält, darauf zugreifen.",
		"share_audio": "Audioaufnahme",
		"share_trans_text": "Transkription",
		"share_summny_text": "Zusammenfassung",
		"share_map": "Mindmap",
		"share_url_pw": "Zugriffsverschlüsselung",
		"share_random_pw": "Zufällig generiertes Passwort",
		"share_url_copy": "Link kopieren",
		"share_url_copy_success": "Link erfolgreich kopiert",
		"share_link_pw": "Zugriffspasswort",
		"share_copy_success": "Die Transkription wurde in die Zwischenablage kopiert!",
		"share_copy_success2": "Zusammenfassung in die Zwischenablage kopiert!",
		"share_speaker": "Sprecher",
		"share_no_update_speaker": "Sprecher kann nicht bearbeitet werden. Leerer Eintrag",
		"share_no_trans":"Keine Transkription",
		"share_no_summny":"Keine Zusammenfassung",
		"share_no_map":"Keine Karte Inhalt",
		"share_trans_text_1": "Transkription",
		"share_summny_text_1": "Zusammenfassung",
		"share_map_1": "Karte",
		"share_save": "Erfolgreich gespeichert",
		"share_no_map": "Kartenbild nicht erstellt",
		"share_update_text": "Transkriptionstext bearbeiten",
		"share_update_text2": "Zusammenfassungstext bearbeiten",
		"showLoading": "Laden...",
		"handwriting": "Handschriftlicher Inhalt",
		"handwritingText": "Handschrift",
		"share_1": "Handschriftliche Inhalte auf dieser Seite werden nicht erkannt",
		"share_2": "Handschrifterkennung bearbeiten",
		"share_3": "Handschrifterkennung",
		"share_4":"Datei wird exportiert, verlassen Sie diese Seite nicht",
		"folder_text":"Ordner",
		"folder_text_update_name":"Umbenennen",
		"folder_text_del":"löschen",
		"folder_text_all":"alle",
		"folder_text_type":"Dateityp",
		"folder_text_audio":"Sprachnotizen",
		"folder_text_writing":"Handschriftliche Notizen",
		"folder_text_file_type":"Dateityp",
		"folder_text_add":"Neuer Ordner",
		"folder_text_input_name":"Bitte geben Sie einen Namen ein",
		"folder_text_cancel":"Stornieren",
		"folder_text_summit":"bestätigen",
		"folder_text_name_not_null":"Der Name darf nicht leer sein.",
		"folder_text_add_success":"Erstellung erfolgreich!",
		"folder_text_del_confirm":"Bestätigung löschen",
		"folder_text_confirm":"Möchten Sie den ausgewählten Ordner wirklich löschen? Nach dem Löschen werden die Notizen im Ordner in den Papierkorb verschoben.",
		"folder_text_del_success":"Löschung erfolgreich!",
		"folder_text_move":"Bewegen nach",
		"folder_text_move_success":"Umzug erfolgreich!",
		"folder_update_name":"Ordner umbenennen",
		"folder_text_update_success":"Änderung erfolgreich!",
		"empty_text":"Keine Daten verfügbar",
		"trans_text_null":"Der transkribierte Text darf nicht leer sein.",
		"summary_text_null":"Die Zusammenfassung darf nicht leer sein.",
		"please_create_folder":"Erstellen Sie zuerst einen Ordner"
	}
}